const Raptor = Mach.requireModule('Raptor');

const SLCommon = Mach.requireModule('SLCommon');
const { env } = SLCommon.getEnv();

const defaultTags = {
  osName: Mach.env.osName ?? '',
  osVersion: Mach.env.osVersion ?? '',
  appVersion: Mach.env.version ?? '',
  platform: Mach.env.isAndroid ? 'Android' : 'iOS',
  pageSource: Mach.env?.schemeParams?.pageSource || '',
  env,
};

function reportRaptor(key: {[k: string]: number;}, tag: {[k: string]: string;} = {}, sample?: number) {
  Raptor?.reportMetrics(key, { ...defaultTags, ...tag }, sample || 1);
}

export { reportRaptor };
